import { Injectable } from '@angular/core';


import * as childProcess from 'child_process';
import * as fs from 'fs';

@Injectable({
  providedIn: 'root'
})
export class ElectronService {
  childProcess: typeof childProcess;
  fs: typeof fs;

  constructor() {

  }
}
